export default __webpack_public_path__ + "static/media/B52_21.7eb8ff84.webp";